// src/services/apiClient.js
import axios from 'axios';

const apiClient = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor para añadir el token a CADA petición
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para manejar errores 401 (Unauthorized)
// Si el token expira, el backend devolverá 401.
// Aquí simplemente redirigimos al login. El AuthContext se encargará de limpiar el estado.
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Limpiamos el token expirado
            localStorage.removeItem('token');
            // Redirigimos al login
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default apiClient;
